<section class="dashboard_content_sec">
    <div class="dashboard_bred_crumb">
        <ul>

            <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg"></li>
            <li>Listing</li>
        </ul>
    </div>


    <div infiniteScroll [infiniteScrollDistance]="10" [infiniteScrollThrottle]="100" (scrolled)="loadMoreEnquiries()">

        <!---jobList Item-->
        <section class="master_add_sec  mb-3" *ngFor="let x of myEnquiryJob;trackBy: trackByJobId;">
            <div class="dashBoard-joblist-sec">
                <div style="cursor: pointer;" class="job-box-company-detail-dashboard d-flex mb-4">
                    <div>
                        <div class="jobcompanyLogo"
                            style="background-color: #d9d9d9 !important;border-radius: 50% !important;">
                            <img *ngIf="x?.job_profiles?.profile_image?.length > 0"
                                src="{{x?.job_profiles?.profile_image[0]?.url}}">
                        </div>
                    </div>
                    <div class="ml-3">
                        <h3>{{x?.job_profiles?.full_name}}</h3>
                        <h4>{{x?.job_profiles?.profession_type}}</h4>
                        <h4>{{x?.job_profiles?.state}}</h4>

                    </div>
                    <div class="d-flex align-self-baseline flex-column ml-auto text-right">
                        <div class="mb-auto ml-auto">

                            <button mat-icon-button *ngIf="loginDetails.type !== 'ADMIN'" [matMenuTriggerFor]="menu1"
                                (click)="$event.stopPropagation()">
                                <mat-icon>more_horiz</mat-icon>
                            </button>

                            <mat-menu #menu1="matMenu" class="table-action-btn">

                                <button type="button" class="view" mat-menu-item
                                    [routerLink]="['/jobseek/jobseeks/talents', x?.job_profiles?.dental_professional_id]">
                                    <span>View Talent Profile</span>
                                </button>

                            </mat-menu>

                        </div>
                        <p class="mt-5">Created : {{x.created_at | date : 'dd-MM-yyyy'}}</p>
                    </div>
                </div>
                <span class="EmploymentType" *ngIf="x?.job_profiles?.work_type">
                    <span class="fullTime" *ngFor="let type of x?.job_profiles?.work_type">
                        {{ type }}
                    </span>
                </span>

                <div class="d-flex" style="margin-top: 15px;">
                    <div class="mr-auto" style="min-width: 180px;">
                        <!-- <ng-container *ngIf="x.status === 'APPROVE'&& loginDetails.type!=='ADMIN'; else emptySpace"> -->

                        <!-- <button *ngIf="x?.matchedStatus" class="fullTime" style="border: none;"  >
                           
                            <ng-container >
                                {{ x.matchedStatus }}
                            </ng-container>
                           
                        </button> -->

                        <button class=" blueThemeBtn" style="border: none; margin-left: 5px;"
                            (click)="messageAcordion(x)" [class.highlight-border]="openAccordionId === x?.id"> Message
                        </button>

                        <button class=" blueThemeBtn" style="border: none; margin-left: 5px;"
                            (click)="EnquiryAcoordion(x)" [class.highlight-border]="openEnquiryAccordionId === x?.id">
                            Enquiry </button>

                        <!-- </ng-container> -->

                        <!-- <ng-template #emptySpace>
                        <div style="height: 36px;"></div>
                    </ng-template> -->
                    </div>

                    <!-- View Details Button -->
                    <div class="blueThemeBtn"
                        [routerLink]="['/jobseek/jobseeks/talents', x?.job_profiles?.dental_professional_id]">View
                        Details</div>
                </div>

                <hr>
                <!-- Message -->

                <div class="message-accordion" *ngIf="openAccordionId === x.id">
                    <div class="messages-container">
                        <!-- Loop through messages -->
                        <ng-container *ngIf="displayMessage?.length > 0; else loadingTemplate">

                            <div *ngFor="let message of displayMessage"
                                [ngClass]="message.message_from === loginDetails?.id ? 'message-right' : 'message-left'">

                                <div class="message-bubble">
                                    <div class="message-header">
                                        <!-- <img class="profile-image"
                                            [src]="message.message_from === loginDetails?.id ? loginDetails.profile_image.url : x.logo"> -->
                                        <img class="profile-image" [src]="message.message_from === loginDetails?.id 
          ? loginDetails?.logo?.url || 'assets/images/default-avatar.png' 
          : x?.job_profiles?.dental_professional?.profile_image?.url || 'assets/images/default-avatar.png'">

                                        <!-- <img class="profile-image" src="{{x.logo}}" alt="Profile Image"> -->
                                        <span class="message-date">{{ message?.created_at | date :'medium' }}</span>
                                        <button mat-icon-button
                                            *ngIf="message.message_from === loginDetails?.id && !message?.deleted_status"
                                            [matMenuTriggerFor]="message1" (click)="$event.stopPropagation()">
                                            <mat-icon>more_horiz</mat-icon>
                                        </button>
                                    </div>
                                    <p class="message-text" *ngIf="!message?.deleted_status">{{ message.message }}</p>
                                    <p class="message-text" *ngIf="message?.deleted_status">This message was deleted</p>
                                    <p class="message-date"
                                        *ngIf="!message?.deleted_status && message.created_at !== message.updated_at">
                                        Edited</p>
                                </div>



                                <mat-menu #message1="matMenu" class="table-action-btn">

                                    <button type="button" class="view" mat-menu-item (click)="editMessage(message)">
                                        <span>Edit</span>
                                    </button>
                                    <button type="button" class="view" mat-menu-item
                                        (click)="deleteMessage(message.id)">
                                        <span>Delete</span>
                                    </button>

                                </mat-menu>
                            </div>
                        </ng-container>
                        <!-- <ng-template #loadingTemplate>
                        <div class="custom-loader custom_logo_loader">
                          <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" style="width: 10%;"/>
                        </div>
                      </ng-template> -->
                    </div>
                    <div class="message-input-container">
                        <input type="text" [(ngModel)]="newMessage" placeholder="Type a message..." />
                        <!-- <button class="send-button" (click)="sendMessage(x)">Send</button> -->
                        <button class="send-button"
                            (click)="EditedMessageId? UpdateMessage(EditedMessageId) :sendMessage(x)">
                            <mat-icon class="send-icon">send</mat-icon>
                        </button>

                    </div>
                </div>


                <!-- Accordion Enquiry -->
                <div class="message-accordion" *ngIf="openEnquiryAccordionId === x.id"
                    style="max-height: 200px; overflow-y: auto;">
                    <div class="messages-container" *ngFor="let enquiry of enquiryData">
                        <div class="message-right" style="max-height: 200px;">
                            <div class="message-bubble">
                                <div class="message-header">
                                    <!-- <img class="profile-image" [src]="loginDetails?.profile_image.url">
                                      -->
                                    <img class="profile-image"
                                        [src]="loginDetails?.logo?.url || 'assets/images/default-avatar.png'">
                                    <span class="message-date">{{ enquiry?.created_at | date :'medium' }} </span>
                                </div>
                                <p class="message-text">{{enquiry.enquiry_description}}</p>
                                <!-- <p class="message-text" > This message was deleted </p> -->

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <!-- No more data -->
        <div *ngIf="endOfData && !loading" class="text-center py-3 text-muted">
            No more enquiries to load.
        </div>

    </div>

</section>